module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/step3-full-01261968f154380e12b0e22f1f3b57c5.jpg";